import {Component, input, signal, WritableSignal} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

import {AnalyticsDirective} from '@selpia/user/tracking';
import {SvgSpriteIcon} from '../svg-sprite';
import {IconButtonComponent} from '../icon-button';
import {NavButton} from './nav-button.model';

@Component({
  selector: 'lib-nav-bar',
  imports: [RouterLink, RouterLinkActive, IconButtonComponent, AnalyticsDirective],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
  host: {
    '(click)': 'closeNav()',
    '[class.open]': 'isMenuOpen()',
    '[style.--link-count]': 'navButtons().length',
  },
})
export class NavBarComponent {
  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  readonly navButtons = input.required<NavButton[]>();

  protected readonly isMenuOpen: WritableSignal<boolean> = signal<boolean>(false);

  toggleNav(event: MouseEvent) {
    event.stopPropagation();
    this.isMenuOpen.update(state => !state);
  }

  closeNav() {
    this.isMenuOpen.set(false);
  }

  protected readonly close = close;
}
